import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
    Box,
    Card,
    InternalGrid,
    Text,
    ButtonGroup,
    LinkIcon,
    FactoryIcon,
    TrashIcon,
} from '@paygreen/paygreen-ui';
import { IsMobile } from '../../../utils/tools';

const CategoryProductIntro = ({
    t,
    chosenProductRef,
    chosenProductName,
    unlinkProduct,
    selectedProduct,
    selectedProductEntity,
}) => {
    const hasEstimationSelected =
        selectedProductEntity?.emissionExternalId ||
        selectedProductEntity?.monetaryRatioMatch;
    return (
        <>
            <Box marginBottom="md">
                <Card
                    hasBackground={true}
                    colorPallet="wab"
                    colorWab="white20"
                    radiusSize="sm"
                    shadowSize="none"
                    paddingTop="xs"
                    paddingBottom="xs"
                    paddingLateral="xs"
                    blockWidth={IsMobile() ? 'none' : 'md'}
                >
                    <InternalGrid
                        childrenMarginBottom="sm"
                        flexWrap="nowrap"
                        displayType="grid"
                        gridTemplateColumns="1fr 1fr"
                        justifyItems="stretch"
                        gridGap="md"
                    >
                        <InternalGrid
                            childrenMarginBottom="sm"
                            style={{ flexDirection: 'column' }}
                            justifyContent="flex-start"
                        >
                            <Text
                                colorPallet="wab"
                                colorWab="black00"
                                textSize="md"
                                htmlTag="strong"
                            >
                                {chosenProductName}
                            </Text>
                            <Text
                                colorPallet="wab"
                                colorWab="grey60"
                                textSize="xs"
                            >
                                {t('matching.addManuallyForm.reference')} :{' '}
                                {chosenProductRef}
                            </Text>
                        </InternalGrid>
                        <InternalGrid
                            childrenMarginBottom="sm"
                            style={{ flexDirection: 'column' }}
                            alignItems="stretch"
                        >
                            <Text
                                colorPallet="wab"
                                colorWab="grey50"
                                htmlTag="strong"
                                textSize="xs"
                            >
                                {t('matching.addManuallyForm.actualEstimation')}
                            </Text>
                            {!hasEstimationSelected && (
                                <Card
                                    hasBackground={true}
                                    colorPallet="wab"
                                    colorWab="grey10"
                                    paddingTop="xs"
                                    paddingBottom="xs"
                                    paddingLateral="xs"
                                    hasDashedBorder
                                    shadowSize="none"
                                >
                                    <Text
                                        colorPallet="wab"
                                        colorWab="grey50"
                                        textSize="sm"
                                        htmlTag="em"
                                    >
                                        {t(
                                            'matching.addManuallyForm.noEstimation',
                                        )}
                                    </Text>
                                    <Text
                                        colorPallet="wab"
                                        colorWab="grey50"
                                        textSize="xs"
                                    >
                                        {t('matching.addManuallyForm.noValue')}
                                    </Text>
                                </Card>
                            )}
                            {!!hasEstimationSelected && (
                                <Card
                                    hasBackground={true}
                                    paddingTop="xs"
                                    paddingBottom="xs"
                                    paddingLateral="xs"
                                    shadowSize="none"
                                >
                                    <InternalGrid
                                        childrenMarginBottom="sm"
                                        flexWrap="nowrap"
                                    >
                                        <InternalGrid
                                            childrenMarginBottom="sm"
                                            style={{ flexDirection: 'column' }}
                                        >
                                            <Text
                                                textSize="sm"
                                                htmlTag="strong"
                                                style={{ lineHeight: '1.2' }}
                                            >
                                                {selectedProductEntity?.emissionFactorName ||
                                                    selectedProductEntity?.monetaryRatioName}
                                            </Text>
                                            {(selectedProductEntity?.monetaryRatioCategoryName ||
                                                selectedProductEntity?.emissionFactorCategoryName) && (
                                                <Text
                                                    textSize="xs"
                                                    htmlTag="em"
                                                    colorWab="grey50"
                                                    marginTop="xs"
                                                    style={{
                                                        lineHeight: '1.2',
                                                    }}
                                                >
                                                    {selectedProductEntity?.emissionFactorCategoryName ||
                                                        selectedProductEntity?.monetaryRatioCategoryName}
                                                </Text>
                                            )}
                                        </InternalGrid>
                                        <ButtonGroup>
                                            <TrashIcon
                                                isActive
                                                htmlTag="button"
                                                title={t(
                                                    'matching.table.unlink',
                                                )}
                                                iconSize="sm"
                                                colorPallet="status"
                                                hasBackground
                                                hasHover
                                                colorStatus="danger"
                                                onClick={unlinkProduct}
                                            />
                                        </ButtonGroup>
                                    </InternalGrid>
                                    <InternalGrid
                                        childrenMarginBottom="sm"
                                        flexWrap="nowrap"
                                        justifyContent="flex-start"
                                    >
                                        <FactoryIcon
                                            colorPallet="wab"
                                            colorWab="grey50"
                                            marginRight="sm"
                                        />
                                        <Text
                                            textSize="xs"
                                            colorPallet="wab"
                                            colorWab="grey30"
                                            htmlTag="strong"
                                        >
                                            {selectedProductEntity?.emissionFactorValue ||
                                                selectedProductEntity?.monetaryRatioValue}
                                        </Text>
                                    </InternalGrid>

                                    <InternalGrid
                                        childrenMarginBottom="sm"
                                        flexWrap="nowrap"
                                        justifyContent="flex-start"
                                    >
                                        <LinkIcon marginRight="sm" />
                                        <Text
                                            colorPallet="theme"
                                            colorTheme="primary"
                                            textSize="xs"
                                            htmlTag="strong"
                                        >
                                            {!!selectedProductEntity.emissionExternalId &&
                                                t(
                                                    'matching.addManuallyForm.equivalentEstimation',
                                                )}
                                            {!!selectedProductEntity.monetaryRatioMatch &&
                                                !selectedProductEntity.emissionExternalId &&
                                                t(
                                                    'matching.addManuallyForm.sectorEstimation',
                                                )}
                                        </Text>
                                    </InternalGrid>
                                </Card>
                            )}
                        </InternalGrid>
                    </InternalGrid>
                </Card>
            </Box>
        </>
    );
};

CategoryProductIntro.propTypes = {
    unlinkProduct: PropTypes.func.isRequired,
    selectedProduct: PropTypes.string,
    chosenProductRef: PropTypes.string,
    chosenProductName: PropTypes.string,
};

export default withTranslation('common')(CategoryProductIntro);
